<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>Networking Night</h1>
        <h4>MISA Networking Night is a networking event where MIS alumni and MIS undergraduates can interact and get to know one another, while also learning more about the IT industry. Through this event, the MIS undergraduates will get to expand their network and form meaningful connections with people from the corporate world.</h4>

        <!-- POSITIONS -->
        <h3>Positions:</h3>


        <!-- POSITION -->
        <h3><b>Logistics Core</b></h3>
        <ul>
            <li>Works directly with Logistics Heads and Programs committee</li>
            <li>Acts as the bridge between the logistics head and other committees of the core team in order to ensure alignment with the event preparations</li>
            <li>Collaborates with the Logistics Heads in fulfilling their duties and executing their provided delegations during the event planning phase and event execution phase</li>
            <li>Assists Logistics Heads in formulating email content to be sent out to participants</li>
            <li>Collaborates with the Programs Committee to ensure alignment with the execution of the program in accordance to the prepared program flow</li>
            <li>Provides logistical support to each committee of the core team for smoother event preparations</li>
            <li>Assists in the facilitation of dry runs for the event to mitigate any concerns that may potentially arise during the event</li>
            <li>Assists in getting details from prize winners during the event</li>
            <li>Will be facilitators during the networking session of Networking Night</li>
        </ul>

        <!-- POSITION -->
        <!-- <h3><b>Human Resources Project Manager</b></h3>
        <ul>
            <li>Human Resource Officers deployed in various MISA projects and events and are tasked to handle the internal relationship of core team members </li>
            <li>Initiate ways in which core team members can bond and develop rapport (e.g. group dynamics and team building)</li>
            <li>Conduct individual consultations with their core team members</li>
            <li>Relays messages to and from the HR Board to the Core Team</li>
            <li>In-charge of internal conflict management and resolution</li>
            <li>Conduct post-event core team evaluations with the HR Performance Management System</li>
        </ul> -->

        <!-- POSITION -->
        <!-- <h3><b>MISA Talents Manager (1)</b></h3>
        <ul>
            <li>Is in-charge of managing the activities of MISA Musika and MISA Hosts, such as scheduling trainings and rehearsals</li>
            <li>Is responsible for making decisions about which performance invitations to accept, and what competitions to join, upon coordination with the members and approval of the AVPs</li>
            <li>Directly coordinate with the AVP for Member Formation for consultation and the AVP for Leadership, Training, and Development for Performance assessment</li>
        </ul> -->

        <!-- POSITION -->
        <!-- <h3><b>MISAyaw Manager (1)</b></h3>
        <ul>
            <li>Is in-charge of MISAyaw, the official dance group of the organization</li>
            <li>Deals with the Company of Ateneo Dancers (CADs) in registering the organization for the yearly RIB: Rhythm in Blue dance competition</li>
            <li>Is responsible for managing the dance group, scheduling trainings and hangouts, and coordinating each member of the group</li>
        </ul> -->

        <!-- POSITION -->
        <!-- <h3><b>MISA ESports Manager (1)</b></h3>
        <ul>
            <li>Is responsible for assisting and facilitating the ESports competition</li>
            <li>Assists in gathering teams for the different games</li>
            <li>Is in charge of technical problems before and during the games</li>
            <li>Directly coordinate with the AVP for Member Formation and VP for Human Resources</li>
        </ul> -->

        <!-- POSITION -->
        <!-- <h3><b>Co-Lab Officer (4)</b></h3>
        <ul>
            <li>Is in-charge of the MISA Co-Lab’s tech competency modules such as MS Office, Google Suite, Basic Coding Languages (ex. Scratch) and operations of each session</li>
            <li>Handles and attends the area sessions of MISA partners — NSTP and Ateneo Gabay</li>
        </ul> -->

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'PrimerHR'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>


